export default {
	forms: {
		list: {
			config: {
				fields: {
					id: {
						config: {
							visible: false
						}
					},
					type: {},
					type_document: {},
					name: {}
				}
			}
		},
		select: {
			config: {
				fields: {
					id: {
						config: {
							visible: false
						}
					},
					type: {},
					type_document: {},
					name: {
					}
				}
			}
		},
		edit: {
			config: {
				fields: {
					id: {
						config: {
							visible: false
						}
					},
					type: {},
					type_document: {},
					name: {
					}
				}
			}
		}
	}
}